import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { useRef as N, useState as g, useContext as C } from "react";
import a from "classnames";
import x from "../Modal/index.js";
import h from "../Button/index.js";
import { ThemeContext as I } from "../ThemeContext/index.js";
import A from "../../icons/Dropdown.js";
import f from "../../icons/Globe.js";
import S from "../../hooks/useClickOutside.js";
const k = "forma-ui__lang-switch-dropdown__root", L = "forma-ui__lang-switch-dropdown__dropdown", O = "forma-ui__lang-switch-dropdown__dropdownIcon", b = "forma-ui__lang-switch-dropdown__dropdownArrow", j = "forma-ui__lang-switch-dropdown__open", D = "forma-ui__lang-switch-dropdown__list", R = "forma-ui__lang-switch-dropdown__item", T = "forma-ui__lang-switch-dropdown__link", z = "forma-ui__lang-switch-dropdown__active", o = {
  root: k,
  dropdown: L,
  dropdownIcon: O,
  dropdownArrow: b,
  open: j,
  list: D,
  item: R,
  link: T,
  active: z
}, K = ({ current: p, items: s, className: m, onChange: u }) => {
  var _;
  const c = N(null), [r, e] = g(!1), { viewport: v } = C(I);
  S(() => e(!1), c);
  const w = (n) => {
    u(n), e(!1);
  };
  return v === "phone" ? /* @__PURE__ */ i("div", { className: a(o.root, m), ref: c, children: [
    /* @__PURE__ */ t(
      "button",
      {
        onClick: () => e(!r),
        className: a(o.dropdown, r && o.open),
        children: /* @__PURE__ */ t(f, { className: o.dropdownIcon })
      }
    ),
    /* @__PURE__ */ i(
      x,
      {
        size: "small",
        open: r,
        onClose: () => e(!1),
        children: [
          /* @__PURE__ */ t("input", { type: "hidden", autoFocus: !0 }),
          /* @__PURE__ */ t("div", { className: o.modalList, children: s.map(({ key: n, name: d }) => {
            const l = location.pathname === "/" ? location.pathname + n : location.pathname.replace("[locale]", n);
            return /* @__PURE__ */ t("div", { className: o.item, children: /* @__PURE__ */ t(
              h,
              {
                as: "a",
                href: l,
                onClick: () => w(n),
                viewStyle: "tertiary",
                fullWidth: !0,
                children: d
              }
            ) }, n);
          }) })
        ]
      }
    )
  ] }) : /* @__PURE__ */ i("div", { className: a(o.root, m), ref: c, children: [
    /* @__PURE__ */ i(
      "button",
      {
        onClick: () => e(!r),
        className: a(o.dropdown, r && o.open),
        children: [
          /* @__PURE__ */ t(f, { className: o.dropdownIcon }),
          /* @__PURE__ */ t("span", { className: o.dropdownText, children: (_ = s.find(({ key: n }) => p === n)) == null ? void 0 : _.name }),
          /* @__PURE__ */ t(A, { className: o.dropdownArrow })
        ]
      }
    ),
    /* @__PURE__ */ t("div", { className: a(o.list, r && o.open), children: s.map(({ key: n, name: d }) => {
      const l = location.pathname === "/" ? location.pathname + n : location.pathname.replace("[locale]", n);
      return /* @__PURE__ */ t("div", { className: o.item, children: /* @__PURE__ */ t(
        h,
        {
          as: "a",
          href: l,
          onClick: () => w(n),
          className: a(o.link, p === n && o.active),
          viewStyle: "text",
          children: d
        }
      ) }, n);
    }) })
  ] });
};
export {
  K as default
};
